import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getWorkdaySeriesAction,getEmployeeList } from '../actions/index';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/src/SuperResponsiveTableStyle.css';
import AdminCommonSection from '../components/adminLayout';
import {constants, KeolisSpinner} from './common/commonExport';

class WorkdaySeries extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedEmployee : "0",
            showSeriesTable : false,
            series_6_checked : false,
            series_14_checked : false
        };
    }
    componentDidMount(){
        const user_admin = this.props.authDetails.role == constants.roles.ADMIN_ROLE  && !this.props.authDetails.impersonateUserId;
        if(user_admin){
            this.props.getEmployeeList(constants.actionUrls.GET_EMPLOYEE_LIST);
        }
        else{
            this.getData();
        }
    }
    // get data for component
    getData(){
        const user_admin = this.props.authDetails.role == constants.roles.ADMIN_ROLE  && !this.props.authDetails.impersonateUserId;
        let empId = user_admin ? this.state.selectedEmployee : this.props.authDetails.impersonateUserId > 0 ? this.props.authDetails.impersonateUserId:this.props.authDetails.employeeID;
        let fetchObj = {
            url:constants.actionUrls.EMPLOYEE_SERIES_URL,
            role: 'emp',
            empId:empId,
            source: 'web',
            pageNum:1,
            filter_6 : this.state.series_6_checked,
            filter_14 : this.state.series_14_checked
        }
        if (empId && empId != "0") {
            this.currentPageNum = 1;
            localStorage.setItem('empId', empId);
            this.props.getWorkdaySeries(fetchObj,(items)=>{ });
        }
    };
    onEmployeeSelection(e,data) {
        const { value } = e.target;
        this.setState({selectedEmployee : value,showSeriesTable:value == "0" ? false : true},() => {
            this.getData();
        });
    }
    onSeriesFilter(no) {
        this.setState({
            series_14_checked : no == 14 ? !this.state.series_14_checked : this.state.series_14_checked,
            series_6_checked : no == 6 ? !this.state.series_6_checked : this.state.series_6_checked
        },() => {
            this.getData();
        });
    }
    renderEmployeeCombo(){
        const user_admin = this.props.authDetails.role == constants.roles.ADMIN_ROLE && !this.props.authDetails.impersonateUserId;
        let showSeriesTable = !user_admin ? true : this.state.showSeriesTable ? true : false;
        return (
            user_admin && Array.isArray(this.props.employees) && this.props.employees.length > 0 ?
            <div className = "series_emp_filter">
                <select className="form-control" value={this.state.selectedEmployee} onChange={this.onEmployeeSelection.bind(this)}>
                    <option key={"0"} value={"0"}>Select employee</option>
                    {
                        this.props.employees.map((emp) => {
                            return <option key={emp.demp_display_Id} value={emp.demp_display_Id}>{emp.emp_full_name}</option>
                        })
                    }
                </select>
                <div className = {`${showSeriesTable?"series_filter_check":"hidden"}`}>
                    <div className="checkboxes">
                        <label htmlFor="x"><input type="checkbox" id="x" onChange = {() => this.onSeriesFilter(14)} /> <span>14 series > 14</span></label>
                        <br /><label htmlFor="y"><input type="checkbox" id="y" onChange = {() => this.onSeriesFilter(6)} /> <span>6 series > 6</span></label>
                    </div>
                </div>
            </div> 
            :
            null
        );
    }
    // rendering claimed workdays component
    renderWorkdays(){
        if (this.props.isLoading) {
            return(
                <tr>
                    <td>
                       <KeolisSpinner />
                    </td>
                </tr>
            );
        }
        else if (this.props.workdays && this.props.workdays.length >= 0) {
            var workdays = this.props.workdays;
            return(
                workdays.length == 0 ?
                <tr>
                    <td colSpan="100%">
                        No records available...
                    </td>
                </tr>
                :
                workdays.map(function (workday, index) {
                    return (
                        <Tr key={index} className="text-center">
                            <Td>{workday.wdy_date} </Td>
                            <Td>{workday.job_type} </Td>
                            <Td>{workday["14_day_series"]} </Td>                    
                            <Td>{workday["6_day_series"]} </Td>  
                        </Tr>
                    );
                })
            );
        } else {
            return(
                <tr>
                    <td>
                        <KeolisSpinner />
                    </td>
                </tr>
            )
        }
    }
    render() {
        let compTitle = 'Workday Series';
        const user_admin = this.props.authDetails.role == constants.roles.ADMIN_ROLE  && !this.props.authDetails.impersonateUserId;
        let showSeriesTable = !user_admin ? true : this.state.showSeriesTable ? true : false;
        return (
            <AdminCommonSection compTitle={compTitle} admin={true}
            tblBody={
                <div>
                    {this.renderEmployeeCombo()}
                    <div id="tblMainActivities" className = {`${showSeriesTable?"":"hidden"}`}>
                        <Table className="table table-striped table-bordered_header table-condensed">
                            <Thead className="thead-default">
                                <Tr className="text-center">
                                    <Th className="text-center">Service Date</Th>
                                    <Th className="text-center">Type</Th>
                                    <Th className="text-center">14 Series</Th>
                                    <Th className="text-center">6 Series</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                            {
                                this.renderWorkdays()
                            }
                            </Tbody>
                        </Table >
                    </div>
                </div>
            }/>
        )
    }
}

function mapStateToProps(state) {
    return {
        workdays: state.series.seriesworkdays,
        isLoading: state.series.isLoading,
        authDetails:state.authState,
        employees : state.filter.employees
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getWorkdaySeries: getWorkdaySeriesAction,
            getEmployeeList : getEmployeeList
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(WorkdaySeries);
